import React from "react";
import ReactDOM from "react-dom";
import { Toaster } from "react-hot-toast";
import App from "./App";
import store from "./store";
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from "redux-persist";
import { Provider } from 'react-redux'
import ExamBoardModal from "./paymentcomp/modal";
import { BrowserRouter } from "react-router-dom";


let persistor = persistStore(store)

ReactDOM.render(
  <React.StrictMode>
    <Toaster />
    <Provider store={store} >
      {/* <ExamBoardModal /> */}
      <PersistGate loading={null} persistor={persistor} >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
